import React, { useState } from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { CtaBanner } from "./Home";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", type: "Building Development", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    // Frontend-only: persist to localStorage as a quick demo
    try {
      const list = JSON.parse(localStorage.getItem("mohan_enquiries") || "[]");
      list.push({ ...form, at: new Date().toISOString() });
      localStorage.setItem("mohan_enquiries", JSON.stringify(list));
    } catch (e) { /* noop */ }
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
    setForm({ name: "", email: "", phone: "", type: "Building Development", message: "" });
  };

  return (
    <main>
      <section className="pt-[140px] pb-16 bg-[#F9F8F6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-4 text-[11px] tracking-[0.2em] text-[#1A1D14]/60 mb-6">
            <span className="inline-block w-1.5 h-1.5 bg-[#B29774]" />
            <span>CONTACT</span>
            <span className="w-10 h-px bg-[#1A1D14]/30" />
            <span>LET’S TALK</span>
          </div>
          <h1 className="font-display text-[56px] md:text-[96px] leading-[0.95] font-medium tracking-[-0.03em]">
            Discuss<br /><span className="text-[#1A1D14]/40">your project.</span>
          </h1>
        </div>
      </section>

      <section className="pb-24 bg-[#F9F8F6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <h2 className="font-display text-[32px] font-medium">Get in touch.</h2>
            <p className="mt-4 text-[#1A1D14]/70 leading-relaxed">
              Tell us a bit about your project and we’ll get back to you with practical next steps.
            </p>
            <div className="mt-10 space-y-6">
              <div>
                <div className="text-xs tracking-[0.2em] text-[#1A1D14]/50">ADDRESS</div>
                <div className="mt-2">Mohan Ltd, 12 Thanet Place<br />CR0 1QP, United Kingdom</div>
              </div>
              <div>
                <div className="text-xs tracking-[0.2em] text-[#1A1D14]/50">PHONE</div>
                <a href="tel:+447405681929" className="mt-2 block link-underline">+44 7405681929</a>
              </div>
              <div>
                <div className="text-xs tracking-[0.2em] text-[#1A1D14]/50">EMAIL</div>
                <a href="mailto:hello@mohan.ltd" className="mt-2 block link-underline">hello@mohan.ltd</a>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <form onSubmit={onSubmit} className="space-y-6 border border-[#1A1D14]/15 p-8 bg-white">
              <div className="grid md:grid-cols-2 gap-6">
                <Field label="Full name" required>
                  <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full border-b border-[#1A1D14]/20 bg-transparent py-2 focus:outline-none focus:border-[#B29774]" />
                </Field>
                <Field label="Email" required>
                  <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full border-b border-[#1A1D14]/20 bg-transparent py-2 focus:outline-none focus:border-[#B29774]" />
                </Field>
                <Field label="Phone">
                  <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full border-b border-[#1A1D14]/20 bg-transparent py-2 focus:outline-none focus:border-[#B29774]" />
                </Field>
                <Field label="Project type">
                  <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="w-full border-b border-[#1A1D14]/20 bg-transparent py-2 focus:outline-none focus:border-[#B29774]">
                    <option>Building Development</option>
                    <option>Commercial Construction</option>
                    <option>Domestic Construction</option>
                    <option>Specialised Construction</option>
                  </select>
                </Field>
              </div>
              <Field label="Tell us about your project" required>
                <textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full border-b border-[#1A1D14]/20 bg-transparent py-2 focus:outline-none focus:border-[#B29774] resize-none" />
              </Field>

              <div className="flex items-center justify-between pt-4">
                {submitted ? (
                  <div className="flex items-center gap-2 text-[#1A1D14]">
                    <Check size={18} className="text-[#B29774]" /> Thanks — your enquiry has been received.
                  </div>
                ) : <span className="text-xs text-[#1A1D14]/50">We usually respond within 2 working days.</span>}
                <button type="submit" className="inline-flex items-center gap-2 bg-[#24291E] text-white px-6 py-3 hover:bg-[#B29774] transition-colors">
                  Send enquiry <ArrowUpRight size={16} />
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      <CtaBanner />
    </main>
  );
}

function Field({ label, required, children }) {
  return (
    <label className="block">
      <div className="text-xs tracking-[0.2em] text-[#1A1D14]/50 mb-1">
        {label.toUpperCase()}{required && <span className="text-[#B29774]"> *</span>}
      </div>
      {children}
    </label>
  );
}
